'use client';

import { type ReactNode } from 'react';
import {
  useEffect,
  useState,
} from 'react';
import { useIsMounted } from 'usehooks-ts';

import styles from './modal-resize.module.scss';

interface ModalResizeProps {
  children: ReactNode;
}

export default function ModalResize(props: ModalResizeProps) {
  const { children } = props;
  const [bottomInset,
    setBottomInset] = useState(0);
  const isMounted = useIsMounted();

  useEffect(() => {
    const handleVisualViewportResize = () => {
      // Detect the bottom inset caused by the keyboard
      if (window.visualViewport) {
        const viewportHeight = window.visualViewport.height;
        const { innerHeight } = window;

        // Calculate the bottom inset (difference between viewport height and inner height)
        const keyboardHeight = innerHeight - viewportHeight;
        setBottomInset(keyboardHeight > 100 ? keyboardHeight : 0); // Use 100px threshold to differentiate true keyboard from small resizes
      }
    };

    if (window.visualViewport) {
      // Listen for visualViewport changes
      window.visualViewport.addEventListener('resize', handleVisualViewportResize);
      window.visualViewport.addEventListener('scroll', handleVisualViewportResize);
    }

    // Clean up event listeners on unmount
    return () => {
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', handleVisualViewportResize);
        window.visualViewport.removeEventListener('scroll', handleVisualViewportResize);
      }
    };
  }, [isMounted]);

  // Apply inset adjustment to modal style
  // Push modal up above the keyboard
  const modalStyle = { marginBottom: `${String(bottomInset)}px` };

  return (
    <div style={modalStyle} className={styles.modalResize}>
      {children}
    </div>
  );
}
